import { pollingService } from '@philips-emr/hpms-provider-commons/lib/services/polling/polling-service';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';

import { InactivityAliases as Aliases, FragmentNames } from '../codegen';

@Controller({ fragment: FragmentNames.INACTIVITY })
class InactivityController {
  @OnMount(Aliases.PANEL_INACTIVITY)
  onMountPanelInactivity(): void {
    pollingService.removePolling('notification');
    pollingService.removePolling('message');
  }
}
export {
  InactivityController,
};
